import { render, staticRenderFns } from "./PillWithLabel.vue?vue&type=template&id=772bac59&"
import script from "./PillWithLabel.vue?vue&type=script&lang=ts&"
export * from "./PillWithLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports